import { useUnit } from 'effector-react'
import { useStyles } from './styles'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { formatNumber } from '@/shared/util/formatNumber'
import { Glow } from '@/shared/ui/glow'

type TotalAssetsValueProps = {
  amount: number | string
}

export const TotalAssetsValue = (props: TotalAssetsValueProps) => {
  const { classes } = useStyles()
  const { amount } = props

  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.leaderboard

  return (
    <div className={classes.root}>
      <Glow background={'rgba(243, 146, 20, 1)'} width={'150px'} top={'48px'} filter="blur(55px)" height={'60px'} />
      <span className={classes.heading}>{texts.total_value}</span>
      <div className={classes.amountContainer}>
        <span>${formatNumber(amount)}</span>
      </div>
    </div>
  )
}
